import styled from "styled-components";

export const TermsConditionsStyled = styled.div`
  padding: 30px;
  border-radius: 12px;

  h1, h2, h3 {
    color: #222;
    font-weight: 700;
        font-family: Inter;
  }

  h1 {
    font-size: 28px;
    text-align: center;
    margin-bottom: 30px;
    font-family: Inter;

  }

  h2 {
    font-size: 20px;
    margin-top: 30px;
    border-left: 4px solid #00a86b;
    padding-left: 10px;
    font-family: Inter;

  }

  p {
    color: #555;
    line-height: 1.6;
    margin: 10px 0;
    font-family: Inter;

  }

  ul {
    margin: 10px 0 10px 20px;
    font-family: Inter;

  }

  li {
    margin: 5px 0;
    font-family: Inter;

  }

  strong {
    color: #000;
    font-family: Inter;

  }
`;
